import * as React from "react";

import BackofficeLink from "app/components/BOComponents/BackOfficeLink";
import { formatCurrency } from "app/utils/filters";

type Props = {
  wallets: any[];
};

export default class WalletList extends React.Component<Props> {
  render() {
    const { wallets } = this.props;

    if (wallets.length === 0) {
      return (
        <div style={{ textAlign: "center" }}>
          <br />
          <br />
          <br />
          User does not belong to any wallet
        </div>
      );
    } else {
      return (
        <table
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={7}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    paddingBottom: "10px",
                    fontWeight: 400,
                  }}
                >
                  <span>Wallets</span>
                </h3>
              </td>
            </tr>
            <tr>
              <th>Name</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {wallets.map((wallet, index) => {
              return (
                <tr key={index}>
                  <td>
                    <BackofficeLink
                      backofficeUrl={`/wallets/${wallet.name}/summary`}
                    >
                      {wallet.display_name}
                    </BackofficeLink>
                  </td>
                  <td>R{formatCurrency(wallet.balance)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }
  }
}
